// The native shell exposes only a snapshot and installation of its verified update.
export const desktopUpdaterService = {
    snapshot: () => window.__CORECRY_UPDATER__?.snapshot() ?? { status: 'idle', version: null },
    install: () => window.__CORECRY_UPDATER__?.install(),
};
